export interface ApiEndpoint {
    name: string;
    url: string;
    description: string;
}

export const API_ENDPOINTS: ApiEndpoint[] = [
    {
        name: 'Development',
        url: 'https://dev.ec-assign-apis.weset.edu.vn',
        description: 'Development server'
    },
    {
        name: 'Local Server',
        url: 'http://localhost:8800',
        description: 'Local development server'
    },
    {
        name: 'Remote Server',
        url: 'http://45.117.82.172:8800',
        description: 'Remote test server'
    }
];
